import React from 'react';
import { withRouter } from 'react-router-dom';
import { withAdsContext } from '../../hocs';
import { historyPropType } from '../../utils';

class IntexAds extends React.Component {
  static propTypes = {
    history: historyPropType.isRequired
  };

  constructor(props) {
    super(props);
    this.pathRef = React.createRef(this.props.history.location.pathname);

    this.mains = {
      elements: [...document.getElementsByTagName('main')],
      checked: []
    };
  }

  componentDidMount() {
    this.adAdv();
    if (this.props.history) {
      this.unlisten = this.props.history.listen(event => {
        const { state } = event;
        const currentMains = [...document.getElementsByTagName('main')];

        const { location } = this.props.history;
        // Cargamos intext solo si ha cambiado el path (en galerias cambia el hash al pasar de item)
        if (location.pathname !== this.pathRef.current) {
          this.pathRef.current = location.pathname;

          // Si no es una pagina de scroll
          if (!state || !state.isScrollPage) {
            this.mains.checked = [];
            this.mains.elements = currentMains;
            this.adAdv();
          } else if (currentMains.length !== this.mains.elements.length) {
            this.mains.elements = currentMains;
            this.adAdv();
          }
        }
      });
    }
  }

  componentWillUnmount() {
    this.unlisten();
  }

  insertIntext = (paragraphs, paragraphNumber, posi) => {
    let sizesm;
    let sizest;
    switch (posi) {
      case 'roba1':
        sizesm = '1x1,300x250,300x300,300x600,fluid';
        sizest = '1x1,300x250,300x300,300x600,fluid';
        break;
      case 'roba2':
        sizesm = '1x1,300x250,300x300,fluid';
        sizest = '1x1,300x250,300x300,fluid';
        break;
      default:
        sizesm = '1x1,320x100,320x50,320x53,fluid';
        sizest = '1x1,728x90,728x250,fluid';
        break;
    }

    const newAd = document.createElement('atres-widget');
    newAd.setAttribute('id', `${posi}-${Math.floor(Math.random() * 1000)}`);
    newAd.setAttribute('data-type', 'ads');
    newAd.setAttribute('data-ad-unit', '32881787/ondacero.es');
    newAd.setAttribute('data-sizesm', sizesm);
    newAd.setAttribute('data-sizest', sizest);
    newAd.setAttribute('data-position', posi);

    const referenceNode = paragraphs[paragraphNumber];
    const parent = referenceNode.parentNode;

    parent.insertBefore(newAd, referenceNode);
  };

  adAdv = () => {
    // Solo en mobile
    if (window.innerWidth <= 1024) {
      try {
        const { checked, elements } = this.mains;

        elements.forEach((main, index) => {
          if (!checked.includes(index)) {
            const paragraphs = [
              ...main.querySelectorAll(
                'article.articleContainer .articleContent > p'
              )
            ].filter(p => p.clientHeight > 100);

            if (paragraphs.length > 2) {
              this.insertIntext(paragraphs, 2, 'roba1');
              checked.push(index);
            }

            if (paragraphs.length > 4) {
              this.insertIntext(paragraphs, 4, 'middle1');
              if (!checked.includes(index)) {
                checked.push(index);
              }
            }

            if (paragraphs.length > 6) {
              this.insertIntext(paragraphs, 6, 'roba2');
              if (!checked.includes(index)) {
                checked.push(index);
              }
            }
          }
        });
      } catch (e) {
        console.error('Error al insertar intext');
      }
    }
  };

  render() {
    return '';
  }
}

export default withRouter(withAdsContext(IntexAds));
